import { Checkbox2 } from '../../../../components/forms/checkbox';
import { FieldGuide, Label, TextInputLarge } from '../../../../components/forms/input';
import { Select2 } from '../../../../components/forms/select';
import { Pageable, usePagination } from '../../../../hooks/use-pagination';
import { MapService } from '../../types/map-service';
import { MapLayerEditorContainer, ChildProps, Changed } from './map-layer-editor-container';
import { LayerTypes } from '../../types/map-layer';
import React from 'react';

export const General = (): JSX.Element => {
  const mapServices = usePagination<Pageable<MapService>>('/map-services', { size: 9999 });

  return <MapLayerEditorContainer>
    {(props: ChildProps): JSX.Element => (
      <div>
        <div className="mb-4">
          <Label name="name">
            Name*
            {props.changedFields?.includes('name') && <Changed />}
          </Label>
          <TextInputLarge {...props.register('name', { required: 'You must provide a value for Layer Name.' })} errors={props.errors} placeholder="Name" />
          <FieldGuide>Layer Name</FieldGuide>
        </div>
        <div className="mb-4">
          <Label name="description">
            Description
            {props.changedFields?.includes('description') && <Changed />}
          </Label>
          <TextInputLarge {...props.register('description')} placeholder="Description" />
          <FieldGuide>Layer Description</FieldGuide>
        </div>
        <div className="mb-4">
          <Label name="sharedId">
            Layer Shared Id
            {props.changedFields?.includes('sharedId') && <Changed />}
          </Label>
          <TextInputLarge {...props.register('sharedId')} placeholder="Layer Shared Id" />
        </div>
        <div className="mb-4">
          <Label name="mapServiceLayerId">
            Map Service Layer Id
            {props.changedFields?.includes('mapServiceLayerId') && <Changed />}
          </Label>
          <TextInputLarge {...props.register('mapServiceLayerId')} placeholder="Map Service Layer Id" />
        </div>
        <div className="mb-4">
          <Label name="type">
            Layer type*
            {props.changedFields?.includes('type') && <Changed />}
          </Label>
          <Select2 {...props.register('type', { required: 'You must provide a value for Layer Type.' })} errors={props.errors}>
            <option value="">Select type</option>
            {layerTypes.map(layerType => <option key={layerType.value} value={layerType.value}>{layerType.label}</option>)}
          </Select2>
        </div>
        <div className="mb-4">
          <Label name="mapServiceId">
            Map Service*
            {props.changedFields?.includes('mapServiceId') && <Changed />}
          </Label>
          <Select2 { ...props.register('mapServiceId', { required: 'You must provide a value for Map Service.' })} errors={props.errors}>
            <option value="">Select type</option>
            {mapServices.data?.content?.map(mapService => <option key={mapService.id as string} value={mapService.id as string}>{mapService.slug}</option>)}
          </Select2>
        </div>
        <div className="mb-4">
          <Label name="clusterBehavior">
            Cluster Behavior
            {props.changedFields?.includes('clusterBehavior') && <Changed />}
          </Label>
          <Select2 { ...props.register('clusterBehavior')}>
            <option value="">Select cluster behavior</option>
            {clusterTypes.map(cluster => <option key={cluster.value} value={cluster.value}>{cluster.label}</option>)}
          </Select2>
        </div>
        <div className="mb-4">
          <Label name="cache">
            Cashing
            {props.changedFields?.includes('cache') && <Changed />}
          </Label>
          <Select2 { ...props.register('cache')}>
            <option value="">Select cashing</option>
            {cacheTypes.map(cache => <option key={cache.value} value={cache.value}>{cache.label}</option>)}
          </Select2>
        </div>
        <div className="mb-4">
          <Checkbox2 {...props.register('isBackground')} label="Is Background" defaultChecked={props.getValues?.()?.isBackground} />
        </div>
      </div>
    )}
  </MapLayerEditorContainer>;
};

const layerTypes = [
  { value: LayerTypes.AGS_LAYER, label: LayerTypes.AGS_LAYER },
  { value: LayerTypes.CAMS_POINT_LAYER, label: LayerTypes.CAMS_POINT_LAYER },
  { value: LayerTypes.COMMERCIAL_BASEMAP, label: LayerTypes.COMMERCIAL_BASEMAP },
  { value: LayerTypes.HP_POINT_LAYER, label: LayerTypes.HP_POINT_LAYER },
  { value: LayerTypes.KML_LAYER, label: LayerTypes.KML_LAYER },
  { value: LayerTypes.SOCIAL_POINT_LAYER, label: LayerTypes.SOCIAL_POINT_LAYER },
  { value: LayerTypes.VIRTUAL_LAYER, label: LayerTypes.VIRTUAL_LAYER },
  { value: LayerTypes.WEATHER_MODEL_LAYER, label: LayerTypes.WEATHER_MODEL_LAYER },
  { value: LayerTypes.WFS_LINE_LAYER, label: LayerTypes.WFS_LINE_LAYER },
  { value: LayerTypes.WFS_POINT_LAYER, label: LayerTypes.WFS_POINT_LAYER },
  { value: LayerTypes.WFS_POLYGON_LAYER, label: LayerTypes.WFS_POLYGON_LAYER },
  { value: LayerTypes.WMS_LINE_LAYER, label: LayerTypes.WMS_LINE_LAYER },
  { value: LayerTypes.WMS_POINT_LAYER, label: LayerTypes.WMS_POINT_LAYER },
  { value: LayerTypes.WMS_POLYGON_LAYER, label: LayerTypes.WMS_POLYGON_LAYER },
  { value: LayerTypes.WMS_RASTER_LAYER, label: LayerTypes.WMS_RASTER_LAYER },
  { value: LayerTypes.WMTS_TILE_LAYER, label: LayerTypes.WMTS_TILE_LAYER },
  { value: LayerTypes.FOLDER, label: LayerTypes.FOLDER },
];

const cacheTypes = [
  { value: 'OFF', label: 'Off' },
  { value: 'MANUAL', label: 'Manual' },
  { value: 'AUTOMATIC', label: 'Automatic' }
];

const clusterTypes = [
  { value: 'CHANGEABLE', label: 'Changeable' },
  { value: 'ALWAYS_ON', label: 'Always On' },
  { value: 'ALWAYS_OFF', label: 'Always Off' },
];
